/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureASquareUpIcon16Light } from './ArrowFigureASquareUpIcon16Light';
import { ArrowFigureASquareUpIcon16Regular } from './ArrowFigureASquareUpIcon16Regular';
import { ArrowFigureASquareUpIcon16Solid } from './ArrowFigureASquareUpIcon16Solid';
import { ArrowFigureASquareUpIcon20Light } from './ArrowFigureASquareUpIcon20Light';
import { ArrowFigureASquareUpIcon20Regular } from './ArrowFigureASquareUpIcon20Regular';
import { ArrowFigureASquareUpIcon20Solid } from './ArrowFigureASquareUpIcon20Solid';
import { ArrowFigureASquareUpIcon24Regular } from './ArrowFigureASquareUpIcon24Regular';
import { ArrowFigureASquareUpIcon24Solid } from './ArrowFigureASquareUpIcon24Solid';
import { ArrowFigureASquareUpIcon32Regular } from './ArrowFigureASquareUpIcon32Regular';
import { ArrowFigureASquareUpIcon64Regular } from './ArrowFigureASquareUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureASquareUpIcon16Light,
        regular: ArrowFigureASquareUpIcon16Regular,
        solid: ArrowFigureASquareUpIcon16Solid,
    },
    20: {
        light: ArrowFigureASquareUpIcon20Light,
        regular: ArrowFigureASquareUpIcon20Regular,
        solid: ArrowFigureASquareUpIcon20Solid,
    },
    24: {
        regular: ArrowFigureASquareUpIcon24Regular,
        solid: ArrowFigureASquareUpIcon24Solid,
    },
    32: {
        regular: ArrowFigureASquareUpIcon32Regular,
    },
    64: {
        regular: ArrowFigureASquareUpIcon64Regular,
    },
};
export var ArrowFigureASquareUpIcon = forwardRef('ArrowFigureASquareUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
